// src/useAnalytics.js
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { initGA, sendPageView } from '../utils/analytics'

export function usePageViewTracking () {
  const location = useLocation()

  // Initialize GA once on first render
  useEffect(() => {
    initGA()
  }, [])

  // Send page_view every time route changes
  useEffect(() => {
    const path = location.pathname + location.search
    sendPageView(path)
  }, [location])
}
